<template>
    <div>
        <FlashNotification />

        <h2 class="title is-2">
            Thank you {{ $meta.userName }}
        </h2>

        <p>
            Your responses will help us assist your enquiry.
        </p>
    </div>
</template>

<script>
import FlashNotification from '../../components/FlashNotification.vue';

export default {
    components: {
        FlashNotification,
    },
};
</script>
